// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__dNrNS","backIcon":"BackButton_backIcon__SDk3y"};